/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".circle-button[_ngcontent-%COMP%]{border-radius:30px;border-width:0;font-size:1rem;font-weight:400;height:32px;width:32px}.circle-button[_ngcontent-%COMP%]:focus{outline:none}.circle-button[_ngcontent-%COMP%]:hover{cursor:pointer;box-shadow:0 0 1rem rgba(0,0,0,.1)}.circle-button[_ngcontent-%COMP%]:active{-webkit-filter:brightness(70%);filter:brightness(70%)}.circle-button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{vertical-align:middle;text-align:center}"];
export { styles as styles };
//# sourceMappingURL=circle-button.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/components/circle-button/circle-button.component.scss.shim.ngstyle.js
// module id = 1488
// module chunks = 26 27 28